// index.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
/**英文语言包 */
// import en from "./en/en.js"
Vue.use(VueI18n);
export const messages = {
  zh: require('./zh-CN/zh.js'),
  en: require('./en/en.js'),
};
/**获取当前语言 */
export function getLanguage() {
  const chooseLanguage = localStorage.getItem('language');

  if (chooseLanguage) return chooseLanguage;
  console.log(chooseLanguage, '语言');
  // if has not choose language
  const language = (
    navigator.language || navigator.browserLanguage
  ).toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }
  return 'en';
}
const ni18n = new VueI18n({
  locale: getLanguage(),
  // set locale messages
  messages,
});

export default ni18n;
